// Unpublished Work © 2019-2026 Deere & Company.

// prettier-ignore
export const defaultTranslations: Record<string, string> = {
    'OPS_CENTER_LANDING_MAIN_TEXT': 'See what’s happening <strong>now</strong> and make better decisions with <strong>all</strong> your data.',
    'OPS_CENTER_LANDING_OPS_CENTER_MOBILE_DESCRIPTION': 'View machine and work data from anywhere.',
    'OPS_CENTER_LANDING_EQUIPMENT_MOBILE_NEW_DESCRIPTION': 'Set up, operate, and maintain your equipment.',
    'loginPage_loginButton': 'Sign In',
    'OPS_CENTER_LANDING_CREATE_ACCOUNT': 'Create Account',
    'OPS_CENTER_MOBILE_TITLE': 'Operations Center Mobile',
    'EQUIPMENT_MOBILE_TITLE': 'Equipment Mobile',
    'APPLE_BADGE_LEGAL': 'Apple and the Apple Logo are trademarks of Apple Inc.',
    'GOOGLE_PLAY_BADGE_LEGAL': 'Google Play and the Google Play logo are trademarks of Google LLC.',
    'copyright': 'Copyright',
    'footer_contactUs': 'Contact Us',
    'footer_privacyData': 'Privacy & Data',
    'accessibility': 'Accessibility',
    'terms_of_use_link': 'Terms of Use',
    'footer_cookie_statement': 'Cookie Statement',
    'DATA_MANAGER_DESCRIPTION_HEADER': 'John Deere Data Manager supports efficient data transfer between your equipment and Operations Center.',
    'DATA_MANAGER_DESCRIPTION_LINE_1': 'Transfer data between a display, computer, and Operations Center with no data-size limits.',
    'DATA_MANAGER_DESCRIPTION_LINE_2': 'Move information of any size without restrictions.',
    'DATA_MANAGER_DESCRIPTION_LINE_3': 'Send data to your account or connected partner organizations.',
    'DATA_MANAGER_DESCRIPTION_LINE_4': 'Compatible with Windows and macOS.',
    'DATA_MANAGER_FOOTER': '*Not compatible with GreenStar™ Original, GreenStar™ 2 1800, or GS3 CommandCenter™ display data.',
    'DATA_MANAGER_DOWNLOAD': 'Download John Deere Data Manager',
    'DATA_MANAGER_WINDOWS_AND_MAC_ONLY': 'Data Manager is only available for Windows and macOS.',
    'SOFTWARE_MANAGER_DESCRIPTION_HEADER': 'Download the latest Generation 4 and G5 CommandCenter™ software and access updated onscreen help using a USB drive.',
    'SOFTWARE_MANAGER_DESCRIPTION_LINE_1': 'Use the same USB drive or C:\\ drive for each download to reduce setup time.',
    'SOFTWARE_MANAGER_DESCRIPTION_LINE_2': 'After installing the update, send the current software version information to John Deere to support your dealer during troubleshooting.',
    'SOFTWARE_MANAGER_DESCRIPTION_LINE_3': 'View Release Notes and Software Installation Instructions on {0}.',
    'SOFTWARE_MANAGER_FOOTER': '*Download only supported for Windows 10.',
    'SOFTWARE_MANAGER_DOWNLOAD': 'Download John Deere Software Manager',
    'SOFTWARE_MANAGER_WINDOWS_ONLY': 'Software Manager is only available for Windows.',
    'NOT_COMPATIBLE_TOOLTIP': 'Not compatible',
    'tool_john_deere_data_manager': 'John Deere Data Manager',
    'tool_john_deere_software_manager': 'John Deere Software Manager',
}
